import React from 'react';
import '../css/WhyChooseUss.css';

const WhyChooseUss = () => {
  const advantagesList = [
    "One of the Trusted Fire & Safety Training Institutes in Bihar, UP & India",
    "Practical & Industry-Oriented Training Approach",
    "Placement Assistance Through Dedicated Placement Cell",
    "100% Practical Training Facilities & Modern Safety Lab",
    "More Than 15 Years of Educational & Training Experience",
    "Experienced & Internationally Qualified Trainers",
    "IGC & IDIP Qualified Faculty Members",
    "Tech IOSH & Grad IOSH Qualified Trainers",
    "Personality Development & Interview Preparation Sessions",
    "Digital Classroom & E-Learning Facilities Through Mobile App",
    "Affordable Fee Structure & Flexible Learning Options"
  ];

  return (
    <section className="gfi-why-choose-section">
      <div className="gfi-why-choose-container">
        
        <div className="gfi-why-choose-mesh-grid">
          
          {/* LEFT SIDE COLUMN: TYPOGRAPHY HEADER & CLASSROOM SNAPSHOT */}
          <div className="gfi-wc-left-column">
            <span className="gfi-wc-upper-tagline">THE GREENFIELD ADVANTAGE</span>
            <h2 className="gfi-wc-main-heading">Why Choose Greenfield Academy?</h2>
            <p className="gfi-wc-sub-caption">
              The factors that make us one of the trusted Fire & Safety training institutes in Bihar, UP & India.
            </p>

            {/* Smart Digital Interactive Classroom Image Container */}
            <div className="gfi-wc-classroom-image-frame">
              <img 
                src="https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=600&auto=format&fit=crop" 
                alt="Greenfield Academy High-Tech Smart Digital Audio Visual Training Lecture Room" 
                className="gfi-wc-classroom-img"
              />
            </div>
          </div>

          {/* RIGHT SIDE COLUMN: VERTICAL FEATURES ACCOLADES STACK */}
          <div className="gfi-wc-right-column">
            <div className="gfi-wc-features-vertical-stack">
              {advantagesList.map((feature, index) => (
                <div key={index} className="gfi-wc-feature-list-item-card">
                  
                  {/* Elegant Circular Green Check Vector Badge */}
                  <div className="gfi-wc-check-icon-bubble">
                    <span className="gfi-wc-check-mark-vector">✓</span>
                  </div>

                  {/* Feature Body Statement Text */}
                  <p className="gfi-wc-feature-statement-txt">{feature}</p>

                </div>
              ))}
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyChooseUss;